// extracted by mini-css-extract-plugin
export default {"input-form":"styles_input-form__tk9J8","inputForm":"styles_input-form__tk9J8"};